import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import ErrorToast from '@/components/toasts/ErrorToast';
import { responseError } from '@/utils/errors';
import actions from '../constants';

export function* datasetSettingsUpdateErrorToast(action) {
  if (!action.silent) {
    yield call(showToast, <ErrorToast
      operation="actions.update"
      name={action.name}
      error={responseError(action).message}
    />);
  }
}

export default function* datasetSettingsToasts() {
  yield takeEvery(actions.UPDATE_DATASET_SETTINGS_ERROR, datasetSettingsUpdateErrorToast);
}
